import React from 'react';
import Slide, { SlideProps } from '@material-ui/core/Slide';
import PropTypes from 'prop-types';

type NkDialogTransitionDirection = 'up' | 'down' | undefined;

const convertDirection = (
  direction: SlideProps['direction'],
): NkDialogTransitionDirection => {
  if (direction === 'up' || direction === 'down') {
    return direction;
  }

  return 'up';
};

const NkDialogTransition = React.forwardRef<unknown, SlideProps>(
  function Transition(props, ref) {
    const direction = convertDirection(props.direction);
    return <Slide direction={direction} ref={ref} {...props} />;
  },
);

NkDialogTransition.propTypes = {
  direction: PropTypes.oneOf(['up', 'down']),
};

export default NkDialogTransition;
